export const CALL_INTEL_VIDEO_URL = 'https://fast.wistia.com/embed/medias/00q24rsmga';
export const CALL_INTEL_PRICE = 199;
